<template>
  <div class="chips-wrapper">
    <div class="chips-container"
      :class="{'chips-container_expanded': !isCollapsed}"
      ref="chips-wrapper">
      <div class="chips" v-for="option in options" :key="option.selectedFieldLabel" @click.stop="">
        <span class="chips__name">{{chipName(option)}}</span>
        <div class="chips__button" @click.stop="deleteFilter(option)"></div>
      </div>
      <!-- <div class="chips chips_test" ref="test-wrapper">
        <span class="chips__name" ref="test"></span>
        <div class="chips__button"></div>
      </div> -->
    </div>
    <div class="chips__collapse-button" 
      v-if="shouldCollapse"
      @click="toggleCoolapse">
      
      <template v-if="isCollapsed">
          Show All {{ options.length }}
      </template>
      <template v-else>
        Hide filters
      </template>
      <base-material-design-icon class="chips__collapse-icon"
        icon="unfoldMoreHorizontal" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'AdvancedChipsBlock',
  mounted () {
    this.calculateWidth()
    window.addEventListener('resize', _.throttle(() => {
      let body = document.getElementsByTagName('body')[ 0 ]
      const style = body.currentStyle || window.getComputedStyle(body)
      if (window.innerWidth < parseFloat(style.maxWidth)) {
        return
      }
      !this.isCalculating && this.calculateWidth()
    }, 100, { trailing: true }), false)
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    replicable: {
      type: Boolean,
      default: true
    },
    forceCalculate: {
      type: Boolean,
      default: false
    },
    copyPage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isCollapsed: true,
      isCalculating: false,
      shouldCollapse: false,
    }
  },
  watch: {
    options () {
      this.$nextTick(this.calculateWidth)
    },
    forceCalculate (value) {
      if (value) {
        this.$nextTick(this.calculateWidth)
      }
    }
  },
  methods: {
    calculateWidth () {
      this.shouldCollapse = false;
      this.isCalculating = true
      const calculateElementWidth = (item) => {
        testChipName.innerHTML = this.chipName(item)
        return testChipWrapper.offsetWidth + parseFloat(testStyle.marginLeft) + parseFloat(testStyle.marginRight)
      }

      const ref = this.$refs[ 'chips-wrapper' ]
      if (!ref) {
        return
      }
      const buttonWidth = 113
      const allowedWidth = ref.parentNode.offsetWidth - buttonWidth
      const testChipName = this.$refs[ 'test' ]
      const testChipWrapper = this.$refs[ 'test-wrapper' ]
      const testStyle = window.getComputedStyle(testChipWrapper)
      let totalChipsWidth = 0;
      for (const item of this.options) {
        totalChipsWidth += calculateElementWidth(item);
        if (totalChipsWidth > allowedWidth) {
          this.shouldCollapse = true;
          break;
        }
      }
      this.isCalculating = false
      testChipName.innerHTML = ''
    },
    chipName (option) {
      const operator = option.operators.operatorVariants.find(item => item.value === option.selectedOperator)
      return `${option.label} ${operator.label} ${option.selectedFilter.text}`
    },
    deleteFilter (option) {
      console.log('delete')
      this.$emit('delete-option', option)
    },
    toggleCoolapse() {
      this.isCollapsed = !this.isCollapsed;
    }
  }
}
</script>

<style scoped lang="scss">
  .chips {
    padding: 2px 2px 2px 12px;
    border-radius: 20px;
    background-color: $rfx-sky-blue;
    height: 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    cursor: default;

    &__name {
      font-size: 12px;
      text-transform: lowercase;
      width: 100%;
      @include ellipsis;
    }

    &__button {
      position: relative;
      cursor: pointer;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      pointer-events: auto;

      &:before,
      &:after {
        position: absolute;
        right: 12px;
        top: 9px;
        content: " ";
        height: 12px;
        width: 2px;
        background-color: $rfx-pearl;
      }

      &:before {
        transform: rotate(45deg);
      }

      &:after {
        transform: rotate(-45deg);
      }

      &:hover {
        &:before, &:after {
          background-color: $rfx-silver;
        }
      }
    }

    &_test {
      opacity: 0;
      position: absolute;
      left: 113px; /*button width*/
      width: fit-content;
    }

    &__collapse-button {
      cursor: pointer;
      display: flex;
      white-space: nowrap;
      align-items: center;
      font-size: 12px;
      gap: 6px;
      padding: 4px 8px;
      border-radius: 20px;

      &:hover {
        background-color: $rfx-medium-steel;
      }
    }

    &__collapse-icon {
      font-size: 16px;
    }
  }

  .chips-wrapper {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    position: relative;
  }

  .chips-container {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    width: 100%;
    overflow: hidden;
    height: 26px;
    z-index: 4;

    &_expanded {
      height: auto;
    }
  }
</style>
